import { Card, CloseIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { reqHlsVideoAssetResourceDecoder } from '../../../../ReqHlsVideo/Decoders';
import { T } from '../../../../Translations';
import { useQueryWithDecoder } from '../../../../UseQueryWithDecoder';
import Loader from '../../../Loader';
import { useFetchExperienceDetail } from '../ChatbotPreview/Previewer/Ready/Details/DefaultSection/PopoverContent/useFetchExperienceDetail';
import { ExperienceResource } from '../CurrentCollectionStep/BuilderV2/Types';
import VideoModal from './VideoModal';

interface Props {
  experienceResource: ExperienceResource;
  hideEnrollAction?: boolean;
}

function ModalState({ experienceResource, hideEnrollAction }: Props) {
  const state = useFetchExperienceDetail(experienceResource);
  const { data, isLoading, error } = useQueryWithDecoder(
    'overview_video',
    experienceResource.links,
    reqHlsVideoAssetResourceDecoder,
  );

  if (isLoading) {
    return (
      <>
        <div className="flex justify-center items-center h-64 w-[135%]">
          <Loader type="spin" />
        </div>
      </>
    );
  }
  if (error || !data) {
    console.error('Failed to load overview video', error);
    return (
      <>
        <T kind="Failed to load overview video" />
      </>
    );
  }

  switch (state.kind) {
    case 'ready':
      return (
        <VideoModal
          video={data}
          experienceResource={experienceResource}
          experienceDetailResource={state.resource}
          hideEnrollAction={hideEnrollAction}
        />
      );
    case 'errored':
      return (
        <Card className="w-64 items-center flex-row justify-around p-4 mx-auto">
          <CloseIcon color="red" />
          <Typography>
            <T kind="Something went wrong" />
          </Typography>
        </Card>
      );
    case 'loading':
    case 'waiting':
      return (
        <div className="flex justify-center items-center h-64 w-[135%]">
          <Loader type="spin" />
        </div>
      );
  }
}

export default observer(ModalState);
